import { render, staticRenderFns } from "./BuroDegistirDialog.vue?vue&type=template&id=a37e8290"
import script from "./BuroDegistirDialog.vue?vue&type=script&lang=ts"
export * from "./BuroDegistirDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports